import { render, staticRenderFns } from "./Notificaciones.vue?vue&type=template&id=17d22fc2&scoped=true&"
import script from "./Notificaciones.vue?vue&type=script&lang=js&"
export * from "./Notificaciones.vue?vue&type=script&lang=js&"
import style0 from "./Notificaciones.vue?vue&type=style&index=0&id=17d22fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d22fc2",
  null
  
)

export default component.exports